module.exports = __webpack_public_path__ + "img/laqun.da3d3fb2.png";